/* istanbul ignore file */

export { JobsModule as default } from "./JobsModule";
